<template>
  <block-item-card
    :min-height="minBlockHeight"
    :show-border="false"
    class="gradient-grey-06-bg"
    style="padding: 20px !important;"
  >
    <v-row>
      <v-col
        cols="12"
        class="rounded-lg"
      >
        <div class="chart-container">
          <div class="chart-header">
            <div class="d-flex flex-column">
              <div class="d-flex align-center">
                <span class="bullet-point">•</span>
                <h3
                  class="chart-title"
                >
                  {{ $t('Dashboard.Banking.LiquidityRisk.RiskAssessment') }}
                </h3>
              </div>
            </div>
          </div>
          <liquidity-risk-assessment-card
            :item="currentItem"
            :title="currentAccountCompany"
            :logo-url="currentAccountCompanyLogoUrl"
          />
        </div>
      </v-col>
    </v-row>
  </block-item-card>
</template>

<script>

import routerTabState        from '@/mixins/routerTabState'
import API from '@/api/Api'
import BlockItemCard from '@/theme/default/components/common/BlockItemCard.vue'
import LiquidityRiskAssessmentCard
  from '@/theme/default/views/banking/risk/liquidity/risk-monitoring/liquidity-risk-assessment/LiquidityRiskAssessmentCard.vue'

export default {
  name      : 'RiskAssessment',
  components: {
    LiquidityRiskAssessmentCard,
    BlockItemCard
  },
  directives: {},
  mixins    : [routerTabState],
  dataStore : {
    MonitoringLiquidity: 'RiskLiquidity.MonitoringLiquidity'
  },
  enums    : {},
  dataModel: null,
  data () {
    return {
      minBlockHeight: 254
    }
  },
  computed: {
    monitoringLiquidity () {
      return this.MonitoringLiquidity?.Data || {}
    },
    liquidityRiskAssessment () {
      return this.monitoringLiquidity?.liquidityRiskAssessment ?? {}
    },
    categories () {
      return this.liquidityRiskAssessment.categories
    },
    currentItem () {
      return this.liquidityRiskAssessment?.currentItem ?? {}
    },
    bankSectorItem () {
      return this.liquidityRiskAssessment?.bankSectorItem ?? {}
    },
    currentAccountCompany () {
      return this.user?.selectedAccountCompany?.shortName
    },
    accountId () {
      return this.user?.selectedAccountId || null
    },
    currentAccountCompanyLogoUrl () {
      return this.user?.selectedAccountCompany?.logoUrl
    }
  },
  created () {
    this.getMonitoringLiquidity()
  },
  methods: {
    async getMonitoringLiquidity () {
      const response = await API.Resource.RiskLiquidity.GetMonitoringLiquidity(this.accountId)
      this.handleResponse(response)
    },

    handleResponse (response, key) {
      const data = API.responseData(response)?.monitoringLiquidity || null

      const errors = API.responseErrors(response) || []

      if (API.isResponseSuccess(response) && data) {
        this.$set(this.MonitoringLiquidity, 'Data', data)
      } else {
        this.$bus.$emit('app:error', errors)
      }
    }
  }
}
</script>

<style scoped>
.gradient-grey-06-bg {
  background-color: var(--v-synthesis-ui-grey-06-base) !important;
}

.bullet-point {
  color: var(--v-synthesis-ui-grey-01-base);
  font-size: 16px;
  font-weight: bold;
  margin-right: 8px;
  display: inline-block;
}

.chart-title {
  font-family: Inter, Aeonik, Roboto, sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  margin: 0;
  color: var(--v-synthesis-ui-grey-01-base);
}

.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0 8px;
}
</style>
